import React, { ButtonHTMLAttributes } from 'react';
import Loader from '../Loader';
import { StyledButton, ButtonLoader, ButtonSize, ButtonVariant } from './shared';

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  size?: ButtonSize;
  fullWidth?: boolean;
  loading?: boolean;
};

export const BaseButton = ({
  size = 'medium',
  fullWidth = false,
  variant = 'primary',
  loading = false,
  children,
  type = 'button',
  disabled,
  // rest btn props, ex: onClick, className
  ...rest
}: ButtonProps & { variant?: ButtonVariant }) => (
  <StyledButton
    $size={size}
    $variant={variant}
    $fullWidth={fullWidth}
    $loading={loading}
    type={type}
    disabled={disabled || loading}
    {...rest}
  >
    {loading ? (
      <>
        <span className="button-loading-content" aria-hidden>
          {children}
        </span>
        <ButtonLoader $variant={variant} aria-hidden>
          <Loader size={24} />
        </ButtonLoader>
      </>
    ) : (
      children
    )}
  </StyledButton>
);

export const PrimaryButton = ({
  size = 'medium',
  fullWidth = false,
  loading = false,
  children,
  type = 'button',
  ...rest
}: ButtonProps) => (
  <BaseButton size={size} fullWidth={fullWidth} variant="primary" type={type} loading={loading} {...rest}>
    {children}
  </BaseButton>
);

export const SecondaryButton = ({
  size = 'medium',
  fullWidth = false,
  loading = false,
  children,
  type = 'button',
  ...rest
}: ButtonProps) => (
  <BaseButton size={size} fullWidth={fullWidth} variant="secondary" type={type} loading={loading} {...rest}>
    {children}
  </BaseButton>
);

export default PrimaryButton;
